function About() {
    return (
      <main>
        <div className="bg-white py-12 px-6">
      <div className="max-w-3xl mx-auto text-center">
        {/* About Us Heading */}
        <h4 className="text-3xl font-extrabold text-gray-900 mb-6">
         Bhattadev University Registration Certificate Management System
        </h4>
        
      </div>
    </div>
      </main>
    )
  }
  
  export default About